import { Setting } from '@witkac/kartamiejska-shared';
import { SettingResource, settingResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł ustawień
 *
 * @export
 * @class SettingsModule
 * @extends {EntityModule<Setting, SettingResource>}
 */
export class SettingsModule extends EntityModule<Setting, SettingResource> {
  constructor() {
    super(settingResource);

    this.state = {
      ...this.state,

      settings: {}
    } as any;

    this.actions = {
      ...this.actions,

      /**
       * Pobiera wybrane ustawienie
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      settingFind: async (context: any, code: string) => {
        const setting: Setting = await this.resource.settingFind(code);
        context.commit('saveSetting', { code, ...setting });
      },
      /**
       * Pobiera wybrane ustawienia publiczne
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      settingFindPublic: async (context: any, code: string) => {
        const setting: Setting = await this.resource.settingFindPublic(code);
        context.commit('saveSetting', { code, ...setting });
      }
    };

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje ustawienie
       *
       * @param {*} localState
       * @param {Setting} setting
       */
      saveSetting: (localState: any, setting: Setting) => {
        localState.settings = { ...localState.settings, [setting.code]: setting };
      }
    };
  }
}

export default new SettingsModule();
